// iter133 / iter147.2 — Global WhatsApp destek yüzen butonu
// Her public sayfada sağ altta sabit; company.whatsapp_number veya phone'u kullanır.
// Admin, Ayarlar > Kurumsal Bilgiler > E-Ticaret WhatsApp Destek panelinden numarayı, mesajı ve açık/kapalı durumu yönetir.
import { MessageCircle } from "lucide-react";
import { useCompany } from "../../context/CompanyContext";

export default function WhatsAppFloat() {
  const { company } = useCompany();
  if (company?.whatsapp_support_enabled === false) return null;
  const rawPhone = company?.whatsapp_number || company?.phone || "";
  const p = (rawPhone || "").replace(/[^0-9]/g, "");
  if (!p) return null;
  const brand = company?.company_name || "Bordo Seramik";
  const customMsg = (company?.whatsapp_message || "").trim();
  const text = encodeURIComponent(customMsg || `Merhaba ${brand}, size ürünlerinizle ilgili bir sorum var.`);
  const href = `https://wa.me/${p.startsWith("90") ? p : (p.startsWith("0") ? "90" + p.slice(1) : "90" + p)}?text=${text}`;
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-float"
      aria-label="WhatsApp ile bize yazın"
      className="fixed right-4 md:right-5 z-30 bottom-[92px] md:bottom-5 group flex items-center gap-2 pl-3 md:pl-4 pr-4 md:pr-5 py-2.5 md:py-3 rounded-full bg-[#25D366] text-white shadow-lg hover:shadow-2xl hover:scale-105 active:scale-95 transition-all"
      style={{ boxShadow: "0 10px 30px -8px rgba(37, 211, 102, 0.55)" }}
    >
      <span className="relative flex items-center justify-center">
        <span className="absolute inline-flex h-full w-full rounded-full bg-white/60 opacity-70 animate-ping"/>
        <MessageCircle size={22} className="relative"/>
      </span>
      <span className="hidden sm:inline text-sm font-semibold tracking-wide">WhatsApp Destek</span>
    </a>
  );
}
